/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Display_NameInputs */

const en_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Name`)
};

const fr_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d’affichage`)
};

const de_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigename`)
};

const it_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da visualizzare`)
};

const ru_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображаемое имя`)
};

const es_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre para mostrar`)
};

const zh_cn2_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示名称`)
};

const ja_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示名`)
};

const hi_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शित होने वाला नाम`)
};

const pt_pt2_display_name = /** @type {(inputs: Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de exibição`)
};

/**
* | output |
* | --- |
* | "Display Name" |
*
* @param {Display_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const display_name = /** @type {((inputs?: Display_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Display_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_display_name(inputs)
	if (locale === "de") return de_display_name(inputs)
	if (locale === "it") return it_display_name(inputs)
	if (locale === "ru") return ru_display_name(inputs)
	if (locale === "es") return es_display_name(inputs)
	if (locale === "zh-CN") return zh_cn2_display_name(inputs)
	if (locale === "ja") return ja_display_name(inputs)
	if (locale === "hi") return hi_display_name(inputs)
	if (locale === "pt-PT") return pt_pt2_display_name(inputs)
	return en_display_name(inputs)
});